<ng-container *transloco="let t">
  @if (!accountMarketplaceSelection().dspAdvertiserId) {
    <IAlert>
      <div>{{ t("amazon-invoices.no_dsp_advertiser_linked_to_this_account") }}</div>
    </IAlert>
  } @else if (!onM19Seat()) {
    <IAlert>
      <div>{{ t("amazon-invoices.no_m19_seat") }}</div>
    </IAlert>
  } @else {
    @if (loading()) {
      <div class="mb-4 flex items-center gap-2">
        <ISpinner [display]="true" />
      </div>
    } @else if (dataSource.dataLength() === 0) {
      <IAlert>
        <div>{{ t("amazon-invoices.no_invoice") }}</div>
      </IAlert>
    } @else {
      <IAlert>
        <div>{{ t("amazon-invoices.info_delay") }}</div>
      </IAlert>
      <div class="flex h-full flex-col justify-between">
        <div class="flex-1">
          <app-overdue-amazon-invoice-warning></app-overdue-amazon-invoice-warning>
          <IDataTable [datasource]="dataSource">
            <table iTable class="w-full">
              <thead iTableHead class="sticky top-0 left-0 z-50 border-none">
                <tr>
                  <th iTableTh>{{ t("common.date") }}</th>
                  <th iTableTh>{{ t("amazon-invoices.invoice_id") }}</th>
                  <th iTableTh>{{ t("amazon-invoices.period") }}</th>
                  <th iTableTh>{{ t("amazon-invoices.amount") }}</th>
                  <th iTableTh>{{ t("amazon-invoices.tax") }}</th>
                  <th iTableTh>{{ t("common.status") }}</th>
                  <th iTableTh>{{ t("amazon-invoices.due_date") }}</th>
                  <th iTableTh></th>
                </tr>
              </thead>
              <tbody>
                @for (amazonInvoice of dataSource.data(); track amazonInvoice.invoiceId) {
                  <tr
                    iTableRow
                    app-amazon-invoices-row
                    [amazonInvoice]="amazonInvoice"
                    [organizationId]="accountMarketplaceSelection().resourceOrganizationId"
                    class="group"
                  ></tr>
                }
              </tbody>
            </table>
          </IDataTable>
        </div>
        <div class="mb-4 flex items-center text-xs text-gray-700">
          {{ t("amazon-invoices.payment_notice") }}
        </div>
      </div>
    }
  }
</ng-container>
